export const CART_KEY = 'cart';
export const TTL_MS = 60 * 60 * 1000;

function readEntry() {
  const raw = localStorage.getItem(CART_KEY);
  if (raw === null) return null;
  try {
    const parsed = JSON.parse(raw);
    if (!parsed || typeof parsed.savedAt !== 'number' || !Array.isArray(parsed.form)) {
      return null;
    }
    return parsed;
  } catch {
    return null;
  }
}

export function load() {
  const entry = readEntry();
  if (entry === null) {
    localStorage.removeItem(CART_KEY);
    return [];
  }
  if (Date.now() - entry.savedAt > TTL_MS) {
    localStorage.removeItem(CART_KEY);
    return [];
  }
  return entry.form;
}

export function save(form) {
  const payload = { savedAt: Date.now(), form: Array.isArray(form) ? form : [] };
  localStorage.setItem(CART_KEY, JSON.stringify(payload));
}

export function clear() {
  localStorage.removeItem(CART_KEY);
}

export function registerCrossTabSync(store) {
  window.addEventListener('storage', (event) => {
    if (event.key !== CART_KEY) return;
    if (event.newValue === null) {
      store.commit('cart/hydrate', []);
      return;
    }
    try {
      const parsed = JSON.parse(event.newValue);
      if (!parsed || typeof parsed.savedAt !== 'number' || !Array.isArray(parsed.form)) return;
      if (Date.now() - parsed.savedAt > TTL_MS) return;
      store.commit('cart/hydrate', parsed.form);
    } catch {
      // ignore malformed payloads written by other code
    }
  });
}
